import React, { useEffect, useState } from 'react';
import { useIframeStore } from '../../../../store/useIframe';

/**
 * @author Claude
 * @date 2025.11.04
 * @description 템플릿 승인 완료 축하 화면
 */

const Step11TemplateApprovedPage: React.FC = () => {
  const { closeIframe } = useIframeStore();
  const [showFireworks, setShowFireworks] = useState(false);

  useEffect(() => {
    // iframe 닫기
    closeIframe();

    // 컴포넌트 마운트 시 폭죽 효과 시작
    setShowFireworks(true);

    // 3초 후 폭죽 효과 종료
    const timer = setTimeout(() => {
      setShowFireworks(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, [closeIframe]);

  return (
    <div style={{ 
      height: '100vh',
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '20px',
      background: 'linear-gradient(135deg, #4CAF50 0%, #45a049 100%)',
      overflow: 'hidden',
      boxSizing: 'border-box'
    }}>
      {/* 폭죽 효과 */}
      {showFireworks && (
        <>
          <div className="firework firework-1" style={{
            position: 'absolute',
            top: '20%',
            left: '20%',
            width: '10px',
            height: '10px',
            borderRadius: '50%',
            background: '#FFD700',
            animation: 'explode 1s ease-out'
          }} />
          <div className="firework firework-2" style={{
            position: 'absolute',
            top: '30%',
            right: '20%',
            width: '10px',
            height: '10px',
            borderRadius: '50%',
            background: '#FF6B6B',
            animation: 'explode 1.5s ease-out'
          }} />
          <div className="firework firework-3" style={{
            position: 'absolute',
            top: '40%',
            left: '70%',
            width: '10px',
            height: '10px',
            borderRadius: '50%',
            background: '#4ECDC4',
            animation: 'explode 2s ease-out'
          }} />
        </>
      )}

      {/* 메인 콘텐츠 */}
      <div style={{
        textAlign: 'center',
        maxWidth: '700px',
        width: '100%',
        position: 'relative',
        zIndex: 10
      }}>
        {/* 성공 아이콘 */}
        <div style={{
          fontSize: '100px',
          marginBottom: '30px',
          animation: showFireworks ? 'bounce 2s ease-in-out infinite' : 'none'
        }}>
          🎊
        </div>

        {/* 메인 타이틀 */}
        <h1 style={{
          fontSize: '48px',
          fontWeight: '900',
          color: 'white',
          marginBottom: '20px',
          lineHeight: '1.2',
          textShadow: '3px 3px 6px rgba(0,0,0,0.3)',
          letterSpacing: '-1px'
        }}>
          축하합니다!
        </h1>

        <h2 style={{
          fontSize: '32px',
          fontWeight: '700',
          color: 'rgba(255, 255, 255, 0.95)',
          marginBottom: '40px',
          lineHeight: '1.3'
        }}>
          템플릿 승인이 모두 완료되었습니다!
        </h2>
          <div style={{
            fontSize: '26px',
            color: 'rgba(255, 255, 255, 0.95)',
            lineHeight: '1.6',
            marginBottom: '30px',
            fontWeight: '700',
            textShadow: '2px 2px 4px rgba(0,0,0,0.2)'
          }}>
            🎉 모든 연동이 완료되었습니다!
          </div>

          <div style={{
            fontSize: '20px',
            color: 'rgba(255, 255, 255, 0.85)',
            lineHeight: '1.5',
            marginBottom: '50px',
            fontWeight: '600',
            textShadow: '1px 1px 3px rgba(0,0,0,0.2)'
          }}>
            이제 비즈메시지를 자유롭게 사용하실 수 있습니다!
          </div>
      </div>

      {/* CSS 애니메이션을 위한 스타일 */}
      <style
        dangerouslySetInnerHTML={{
          __html: `
            @keyframes explode {
              0% {
                transform: scale(0) rotate(0deg);
                opacity: 1;
              }
              50% {
                transform: scale(1.5) rotate(180deg);
                opacity: 0.8;
              }
              100% {
                transform: scale(3) rotate(360deg);
                opacity: 0;
              }
            }

            @keyframes bounce {
              0%, 20%, 50%, 80%, 100% {
                transform: translateY(0);
              }
              40% {
                transform: translateY(-15px);
              }
              60% {
                transform: translateY(-8px);
              }
            }

            .firework {
              box-shadow: 
                0 0 15px currentColor,
                0 0 25px currentColor,
                0 0 35px currentColor;
            }
          `
        }}
      />
    </div>
  );
};

export default Step11TemplateApprovedPage;